$(function() {

  /**
   * エラー項目が入力されたらエラー表示をしない。
   */
  var stTrigger = (function() {
    var $trigger = $('.st-Trigger');
    var $controls = $('#' + $trigger.attr('aria-controls'));
    $trigger.on('click', function(e) {
      if($trigger.attr('aria-expanded') === 'false') {
        $trigger.attr('aria-expanded', 'true');
        $controls.attr('aria-hidden', 'false');
        $('html, body').css({
          'width': '100%',
          'height': '100%',
          'overflow': 'hidden',
          'position': 'fixed',
          'top': '0',
          'left': '0'
        });

      } else {
        $trigger.attr('aria-expanded', 'false');
        $controls.attr('aria-hidden', 'true');
        $('html, body').css({
          'width': '',
          'height': '',
          'overflow': '',
          'position': '',
          'top': '',
          'left': ''
        });
      }
      e.stopPropagation();
    });

    $('.st-Drawer_Bg').on('click', function(e) {
      $trigger.attr('aria-expanded', 'false');
      $controls.attr('aria-hidden', 'true');
      $('html, body').css({
        'width': '',
        'height': '',
        'overflow': '',
        'position': '',
        'top': '',
        'left': ''
      });
      e.stopPropagation();
    });

  })();

}());
